import { Component, OnInit } from '@angular/core';
import { buildInfo } from '../../../build-info';
import { formatBuildStamp } from './build-stamp';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styles: ['.build-stamp { margin-left: 0.75em; font-size: 0.85em; opacity: 0.6; }'],
})
export class FooterComponent implements OnInit {
  test: Date = new Date();
  buildStamp: string = formatBuildStamp(buildInfo.builtAt);

  constructor() { }

  ngOnInit() {
  }

}
